import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from 'src/config/config';
import { apiConstants } from '../constant/apiConstant';
import { map } from 'rxjs';
import { commonFunctionService } from '../utils/commonFunctions';

@Injectable({
    providedIn: 'root'
})
export class AcademicCalendarService {

    schoolData = localStorage.getItem('schoolAllInfo');
    parsedData = JSON.parse(this.schoolData);
    academicId = this.parsedData?.currentAcademicId;
    private URL_V3 = AppSettings.API_ENDPOINT_V3;
    private language = "en";
    private params = new HttpParams().set("lang", this.language).set("academicId", this.academicId);

    constructor(private http: HttpClient, private commonFunctionService: commonFunctionService) { }

    getStaffListService() {
        return this.http
            .get(this.URL_V3 + apiConstants.getStaffListAPIEndpoint, {
                headers: this.commonFunctionService.appendHeader(),
                params: this.params,
            })
            .pipe(map((res) => res));
    }

    getEventListService(startDate, endDate, eventCategoryId) {
        const queryParams = {
            "lang": this.language,
            "academicId": this.academicId,
            "startDate": startDate,
            "endDate": endDate,
            "eventCategoryId": eventCategoryId
        }
        return this.http
            .get(this.URL_V3 + apiConstants.getEventAPIEndpoint, {
                headers: this.commonFunctionService.appendHeader(),
                params: queryParams,
            })
            .pipe(map((res) => res));
    }

    createEventService(body: any) {
        const headers = this.commonFunctionService.appendHeader();
        const url = this.URL_V3 + apiConstants.createEventAPIEndpoint;
        return this.http.post(url, body, { headers }).pipe(map((res) => res));
    }

    editEventService(body: any) {
        const headers = this.commonFunctionService.appendHeader();
        const url = this.URL_V3 + apiConstants.editEventAPIEndpoint;
        return this.http.put(url, body, { headers }).pipe(map((res) => res));
    }

    deleteEventService(body: any) {
        const headers = this.commonFunctionService.appendHeader();
        const url = this.URL_V3 + apiConstants.deleteEventAPIEndpoint;
        return this.http.delete(url, { body, headers }).pipe(map((res) => res));
    }

    publishCalendarService(body: any) {
        const headers = this.commonFunctionService.appendHeader();
        const url = this.URL_V3 + apiConstants.updateIsPublishedEventCalendarAPIEndpoint;
        return this.http.put(url, body, { headers }).pipe(map((res) => res));
    }
}
